import { defineComponent as _defineComponent } from 'vue'
import {PropType, ref} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'InfoSnackbar',
  props: {
  status: {
    required: true,
    type: String as PropType<string>,
  },
  textArray: {
    required: true,
    type: Array as PropType<string[]>
  },
},
  setup(__props, { expose }) {

const props = __props;




const isVisible = ref<boolean>(false);
const show = () => {
  isVisible.value = true;
}

expose({
  show,
})


return { __sfc: true,props, isVisible, show }
}

})